import React from "react";

const pavilions = [
     {
    title: "India's Leadership in Millets",
    description:
      "Showcasing India's global leadership in millet mainstreaming through policy initiatives and national millet missions.",
  },
  {
    title: "Health & Lifestyle Pavilion",
    description:
      "Nutritionists, hospitals, Ayurveda practitioners, and wellness brands offer health screenings and diet consultations.",
  },
  {
    title: "Cultural & Heritage Pavilion",
    description:
      "Folk performances, millet crafts, and heritage cuisine displays bringing farm-to-fork storytelling to life.",
  },
  {
    title: "Innovation & Start-up Pavilion",
    description:
      "Start-ups, industry players, and incubators showcase millet-based products, technology, and business models.",
  },
  {
    title: "Millet Business Connect",
    description:
      "A B2B zone featuring banks, incubators, e-commerce platforms, government ministries, foreign embassies, and dedicated pitch sessions.",
  },
  
  
  {
    title: "Millet Food Court",
    description:
      "20–25 curated stalls with live demos and regional millet dishes — taste, experience, and celebrate millets.",
  },
 
];

const ExhibitorServices = () => {
  return (
    <div className="pavilion-contact-page">
      <style>{`
        .pavilion-contact-page {
          font-family: 'Outfit', sans-serif;
          color: #222;
        }

        .pavilion-hero {
          text-align: center;
          padding: 120px 20px 40px;
          background: linear-gradient(135deg, #1c1f26, #2a2f3a);
          color: #fff;
        }

        @media (max-width: 970px) {
          .pavilion-hero {
            padding: 90px 20px 40px;
          }
        }

        @media (max-width: 480px) {
          .pavilion-hero {
            padding: 75px 20px 30px;
          }
        }

        .pavilion-hero .badge {
          display: inline-block;
          background: #9b2230;
          color: #fff;
          padding: 6px 16px;
          border-radius: 9999px;
          font-size: 0.8rem;
          font-weight: 600;
          margin-bottom: 1rem;
        }

        .pavilion-hero h1 {
          font-size: clamp(1.6rem, 4vw, 2.4rem);
          margin-bottom: 1rem;
        }

        .pavilion-hero h1 span {
          color: #ff6b6b;
        }

        .pavilion-hero p {
          max-width: 700px;
          margin: 0 auto;
          font-size: 1rem;
          color: rgba(255, 255, 255, 0.85);
        }

        .pavilion-grid-section {
          padding: 60px 20px;
          background: #f5f5f5;
        }

        .pavilion-grid {
          max-width: 1100px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 1.5rem;
        }

        .pavilion-card {
          background: #fff;
          border-radius: 12px;
          padding: 1.8rem 1.5rem;
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.07);
          border-top: 4px solid #9b2230;
          text-align: left;
          transition: transform 0.25s ease, box-shadow 0.25s ease;
        }

        .pavilion-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 10px 28px rgba(0, 0, 0, 0.12);
        }

        .pavilion-card h3 {
          font-size: 1.1rem;
          color: #9b2230;
          margin-bottom: 0.6rem;
          font-family: "jacques francois", serif;
        }

        .pavilion-card p {
          font-size: 0.9rem;
          line-height: 1.6;
          color: #444;
          margin: 0;
        }

        .pavilion-contact-section {
          background: linear-gradient(135deg, #2a2f3a, #1c1f26);
          color: #fff;
          padding: 60px 20px 70px;
          text-align: center;
        }

        .pavilion-contact-section h2 {
          font-size: 1.8rem;
          margin-bottom: 0.6rem;
          font-family: "jacques francois", serif;
        }

        .pavilion-contact-section > p {
          max-width: 650px;
          margin: 0 auto 2rem;
          color: rgba(255, 255, 255, 0.8);
          font-size: 0.95rem;
        }

        .contact-cards {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          gap: 1.5rem;
        }

        .contact-card {
          background: rgba(255, 255, 255, 0.06);
          border: 1px solid rgba(255, 255, 255, 0.15);
          border-radius: 12px;
          padding: 1.8rem 2rem;
          min-width: 250px;
          text-align: left;
        }

        .contact-card h4 {
          font-size: 0.85rem;
          text-transform: uppercase;
          letter-spacing: 1px;
          color: #ff9d9d;
          margin-bottom: 0.6rem;
        }

        .contact-card a,
        .contact-card span {
          font-size: 1.05rem;
          font-weight: 600;
          color: #fff;
          text-decoration: none;
        }

        .contact-card a:hover {
          text-decoration: underline;
        }

        .contact-card .placeholder-note {
          display: block;
          margin-top: 0.4rem;
          font-size: 0.75rem;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.5);
        }

        .contact-cta {
          margin-top: 2.5rem;
        }

        .contact-cta a {
          display: inline-block;
          background: #9b2230;
          color: #fff;
          padding: 0.75rem 2rem;
          border-radius: 8px;
          font-weight: 600;
          text-decoration: none;
          transition: background 0.3s ease;
        }

        .contact-cta a:hover {
          background: #7a1a25;
        }

        @media (max-width: 900px) {
          .pavilion-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 600px) {
          .pavilion-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <section className="pavilion-hero">
        <div className="badge">MAGIC 2026 Expo</div>
        <h1>
          Interested in Setting up a <span>Stall?</span>
        </h1>
        <p>
          The Millet & Ancient Grains Expo at MAGIC 2026 features thematic
          pavilions open to start-ups, industry. Explore the pavilions below and reach out to us to
          confirm your participation.
        </p>
      </section>

      <section className="pavilion-grid-section">
        <div className="pavilion-grid">
          {pavilions.map((p, idx) => (
            <div className="pavilion-card" key={idx}>
              <h3>{p.title}</h3>
              <p>{p.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="pavilion-contact-section">
        <h2>Get in Touch</h2>
        <p>
          For bookings, sponsorship queries, or any other
          participation details, contact the MAGIC 2026 team directly.
        </p>

        <div className="contact-cards">
          <div className="contact-card">
            <h4>Email</h4>
            <a href="mailto:magic2026@millets.res.in">
              magic2026@millets.res.in
            </a><br></br>
            <a href="mailto:maharishi@millets.res.in">
              maharishi@millets.res.in
            </a> <br></br>
            <a href="mailto:maharishi.iimr@gmail.com">
              maharishi.iimr@gmail.com
            </a>
            
          </div>

          <div className="contact-card">
            <h4>Phone</h4>
            {/* TODO: Replace with your actual phone number */}
            <span>L.Rachana  : +91 9490607193</span>
            <br></br>
            <span>Mohitha Kiran : +91 9877659372</span>
          </div>
        </div>

        <div className="contact-cta">
          <a href="/magic2026_registration" target="_blank" rel="noopener noreferrer">
            Register for MAGIC 2026
          </a>
        </div>
      </section>
    </div>
  );
};

export default ExhibitorServices;